<ziro-collapsible-section-card
  [isSwitchHidden]="true"
  [title]="'tkey;admin.ldap.groups.title'"
  [isCollapsible]="false"
  [hidden]="isProxyServerEnabled()"
>
  <div class="card bg-light mb-3">
    <div class="card-body" [innerHTML]="'tkey;admin.ldap.groups.text' | escapeHtml"></div>
  </div>

  <div class="row mb-2" data-automation="ldap-group-admin-input">
    <div class="offset-xl-1 col-xl-6">
      <ziro-select fieldId="administratorsGroup"></ziro-select>
    </div>
    <div class="col-xl-2">
      @if (formData.administratorsGroup) {
        <ziro-view-members
          [members]="administratorsGroup.matches"
          [state]="administratorsGroup.viewMembersState"
          [errorMessage]="administratorsGroup.errorMsg"
        ></ziro-view-members>
      }
    </div>
  </div>

  <div class="row mb-2" data-automation="ldap-group-global-helpdesk-input">
    <div class="offset-xl-1 col-xl-6">
      <ziro-select fieldId="globalHelpdeskGroup"></ziro-select>
    </div>
    <div class="col-xl-2">
      @if (formData.globalHelpdeskGroup) {
        <ziro-view-members
          [members]="globalHelpdeskGroup.matches"
          [state]="globalHelpdeskGroup.viewMembersState"
          [errorMessage]="globalHelpdeskGroup.errorMsg"
        ></ziro-view-members>
      }
    </div>
  </div>

  <div class="row mb-2" data-automation="ldap-group-sitemac-input">
    <div class="offset-xl-1 col-xl-6">
      <ziro-select fieldId="siteBasedHelpdeskGroup"></ziro-select>
    </div>
    <div class="col-xl-2">
      @if (formData.siteBasedHelpdeskGroup) {
        <ziro-view-members
          [members]="siteBasedHelpdeskGroup.matches"
          [state]="siteBasedHelpdeskGroup.viewMembersState"
          [errorMessage]="siteBasedHelpdeskGroup.errorMsg"
        ></ziro-view-members>
      }
    </div>
  </div>

  <div class="row" data-automation="ldap-group-lookup-nested-groups-input">
    <div class="offset-xl-1 col-xl-6">
      <ziro-checkbox fieldId="lookupNestedGroups"></ziro-checkbox>
    </div>
  </div>

  <div class="d-flex justify-content-end">
    <ziro-submit-button
      [isPending]="isSubmitting"
      [isDisabled]="isSubmitting"
      [label]="'tkey;global.button.save.text'"
      [dataAutomation]="'ldap-management-permissions-save'"
      [buttonStyle]="ButtonStyles.OUTLINE_PRIMARY"
      [icon]="ziroIcons.SAVE_SUCCESS"
      [iconPending]="ziroIcons.SAVING"
      [formSubmitSubject]="_validateAndSubmitSource"
    ></ziro-submit-button>
  </div>
</ziro-collapsible-section-card>
